module.exports = __webpack_public_path__ + "img/swpr-insi-pres.30967075.svg";